import React, { useState } from "react";
import CustomSelect from "../../components/FormFields/CustomSelect";
import { reportOptions } from "../../components/Reports/reports.config";
import MedicineReport from "../../components/Reports/MedicineReport/MedicineReport";

const GenerateReportScreen = () => {
  const [selectedReport, setSelectedReport] = useState("");

  const handleChange = (event) => {
    setSelectedReport(event.target.value);
  };

  return (
    <div className="mt-4 bg-white p-3">
      <div className="w-25 m-5">
        <CustomSelect
          options={reportOptions}
          name="Report"
          selectedValue={selectedReport}
          label="Select Report"
          onChange={handleChange}
          initialLabel={true}
          required={true}
        />
      </div>
      {selectedReport === "meds_administration" && (
        <MedicineReport></MedicineReport>
      )}
    </div>
  );
};

export default GenerateReportScreen;
